var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgRotate = function SvgRotate(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M10.75 0a3 3 0 0 1 3 3v15.083a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3zm-.719 1.757H3.72a2 2 0 0 0-2 2v13.57a2 2 0 0 0 2 2h6.312a2 2 0 0 0 2-2V3.756a2 2 0 0 0-2-2zM6.035 15.813h1.68a.878.878 0 1 1 0 1.756h-1.68a.878.878 0 1 1 0-1.756z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d8d8d8",
    d: "M18.298 5.643a3 3 0 0 1 3 3v7.464a3 3 0 0 1-3 3h-3.631v-1.683h3.912a1 1 0 0 0 1-1V8.326a1 1 0 0 0-.884-.993l-.116-.007h-3.912V5.641z"
  }))));
};
export default SvgRotate;